<template>
    <div class="" style="box-sizing: border-box">
        <div class="header_warpper">
            <div class="left">
                <el-tabs v-model="query.type" @tab-click="handleClick" style="margin-right: 10px">
                    <el-tab-pane label="全部" name="0"></el-tab-pane>
                    <el-tab-pane label="今日" name="1"></el-tab-pane>
                    <el-tab-pane label="昨日" name="2"></el-tab-pane>
                    <el-tab-pane label="本周" name="3"></el-tab-pane>
                    <el-tab-pane label="上周" name="4"></el-tab-pane>
                    <el-tab-pane label="本月" name="5"></el-tab-pane>
                    <el-tab-pane label="上月" name="6"></el-tab-pane>
                </el-tabs>
                <el-input v-model="query.seek" placeholder="单号/备注" style="margin-left: 68px"></el-input>
                <el-button type="primary" style="margin-right: 10px" @click="searchIt">{{ $t('common.search') }}</el-button>
                <el-button plain @click="dialogVisible = !dialogVisible" style=""
                    >{{ $t('common.filter') }}<i class="el-icon-arrow-up el-icon--right" v-if="!dialogVisible"></i>
                    <i class="el-icon-arrow-down el-icon--right" v-else></i>
                </el-button>
            </div>

            <div class="right" style="">
                <el-button type="" plain @click="refush">{{ $t('common.refresh') }}</el-button>
                <el-button type="primary" @click="add" style="margin-right: 10px">{{ $t('common.add') }}</el-button>
                <el-dropdown trigger="click" @command="handleCommand">
                    <el-button plain> 更多<i class="el-icon-arrow-down el-icon--right"></i> </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="1" v-if="perData.allow_check == 1">{{ $t('common.audit') }}</el-dropdown-item>
                        <el-dropdown-item command="2">{{ $t('common.export') }}</el-dropdown-item>
                        <el-dropdown-item command="3" v-if="perData.allow_print == 1">{{ $t('common.print') }}</el-dropdown-item>
                        <el-dropdown-item command="4" v-if="perData.allow_dele == 1">{{ $t('common.delete') }}</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>

        <div v-show="dialogVisible" class="dialog_warpper">
            <div class="dialog">
                <el-tabs v-model="activeName" @tab-click="handleClicks">
                    <el-tab-pane label="常用条件" name="0">
                        <div class="box2">
                            <div style="margin-top: 15px" class="block">
                                <p>日期</p>
                                <el-radio-group v-model="query.type" size="medium" @input="changeType">
                                    <el-radio-button label="1">今日</el-radio-button>
                                    <el-radio-button label="2">昨日</el-radio-button>
                                    <el-radio-button label="3">本周</el-radio-button>
                                    <el-radio-button label="4">上周</el-radio-button>
                                    <el-radio-button label="5">本月</el-radio-button>
                                    <el-radio-button label="6">上月</el-radio-button>
                                </el-radio-group>
                            </div>
                            <div class="block">
                                <p class="demonstration">自定义</p>
                                <el-date-picker
                                    v-model="value2"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    align="right"
                                    style="width: 80%"
                                    @change="changeDate"
                                    value-format="yyyy-MM-dd"
                                >
                                </el-date-picker>
                            </div>
                            <div class="block">
                                <p class="demonstration">{{ $t('common.billType') }}</p>
                                <el-select
                                    v-model="query.billtype_no"
                                    filterable
                                    default-first-option
                                    clearable
                                    placeholder="请选择"
                                    style="width: 80%"
                                >
                                    <el-option
                                        v-for="(item, index) in pullData.billtype"
                                        :key="index"
                                        :label="item.billtype_no + ' - ' + item.billtype_name"
                                        :value="item.billtype_no.toString()"
                                    >
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="block">
                                <p>{{ $t('common.auditStatus') }}</p>
                                <el-radio-group v-model="query.check">
                                    <el-radio label="0">{{ $t('common.all') }}</el-radio>
                                    <el-radio label="未审核">未审核</el-radio>
                                    <el-radio label="已审核">已审核</el-radio>
                                </el-radio-group>
                            </div>
                            <div class="block">
                                <p class="demonstration">客户</p>
                                <el-select
                                    v-model="query.cust_no"
                                    filterable
                                    default-first-option
                                    clearable
                                    placeholder="请选择"
                                    style="width: 80%"
                                >
                                    <el-option
                                        v-for="(item, index) in pullData.cust"
                                        :key="index"
                                        :label="item.cust_no + ' - ' + item.cust_name"
                                        :value="item.cust_no"
                                    >
                                    </el-option>
                                </el-select>
                            </div>

                            <div class="block">
                                <p class="demonstration">账户</p>
                                <el-select
                                    v-model="query.bank_no"
                                    filterable
                                    default-first-option
                                    clearable
                                    placeholder="请选择"
                                    style="width: 80%"
                                >
                                    <el-option
                                        v-for="(item, index) in pullData.bank"
                                        :key="index"
                                        :label="item.bank_no + ' - ' + item.bank_name"
                                        :value="item.bank_no"
                                    >
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="block">
                                <p class="demonstration">建单人</p>
                                <el-select
                                    v-model="query.build_no"
                                    filterable
                                    default-first-option
                                    clearable
                                    placeholder="请选择"
                                    style="width: 80%"
                                >
                                    <el-option
                                        v-for="(item, index) in pullData.build"
                                        :key="index"
                                        :label="item.build_no + ' - ' + item.build_name"
                                        :value="item.build_no"
                                    >
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="高级筛选" name="1">
                        <div class="box1">
                            <el-button type="success" icon="el-icon-plus" plain circle @click="showInput"></el-button>
                            <div
                                style="margin-top: 20px; display: flex; flex-wrap: wrap; align-items: center"
                                v-for="(tag, index) in bonusData"
                                :key="index"
                            >
                                <el-select
                                    @change="selectOne1(index, $event)"
                                    v-model="bonusData[index].field"
                                    filterable
                                    default-first-option
                                    placeholder="请选择"
                                    style="width: 150px"
                                >
                                    <el-option
                                        v-for="item in pullData.screen_pull[0].field"
                                        :key="item.name_no"
                                        :label="item.name"
                                        :value="item.name_no"
                                    ></el-option>
                                </el-select>
                                <span style="display: inline-block; margin: 0 10px">-</span>
                                <el-select
                                    v-model="bonusData[index].condition"
                                    filterable
                                    default-first-option
                                    placeholder="请选择"
                                    style="width: 150px"
                                >
                                    <el-option
                                        v-for="item in pullData.screen_condition"
                                        :key="item.name_no"
                                        :label="item.name"
                                        :value="item.name_no"
                                    ></el-option>
                                </el-select>
                                <span style="display: inline-block; margin: 0 10px">-</span>
                                <el-select
                                    v-model="bonusData[index].parameter"
                                    filterable
                                    default-first-option
                                    placeholder="请选择"
                                    v-if="Array.isArray(arrs[index]) && arrs[index].length > 0"
                                    style="width: 150px"
                                >
                                    <el-option
                                        v-for="item in arrs[index]"
                                        :key="item.kind_no"
                                        :label="item.kind_name"
                                        :value="item.kind_no"
                                    ></el-option>
                                </el-select>
                                <el-input style="width: 150px" v-model="bonusData[index].parameter" placeholder="请输入" v-else></el-input>
                                <el-button
                                    style="margin-left: 15px"
                                    type="danger"
                                    icon="el-icon-minus"
                                    plain
                                    circle
                                    @click.native.prevent="deleteRow(index, bonusData)"
                                    size="small"
                                ></el-button>
                            </div>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="screen">确 定</el-button>
            </span>
        </div>
        <div class="table">
            <vxe-table
                border
                auto-resize
                :data="backData"
                ref="table"
                height="620"
                :footer-method="footerMethod"
                show-footer
                :key="refushTable"
            >
                <vxe-table-column type="checkbox" fixed="left" width="50" align="center"></vxe-table-column>
                <vxe-table-column title="序号" type="seq" field="seq" fixed="left" width="50" align="center">
                    <template slot="header">
                        <i class="el-icon-setting" style="font-size: 18px" @click="changeTable"></i>
                    </template>
                </vxe-table-column>
                <template v-for="(item, index) in rkKeyList">
                    <vxe-table-column
                        :key="item.field + index"
                        :field="item.field"
                        :title="item.column_name"
                        align="left"
                        :width="item.column_width"
                        v-if="item.column_status == 1 && item.column_name != '单号' && item.column_name != '审核'"
                    >
                    </vxe-table-column>
                    <vxe-table-column
                        :key="item.field + index"
                        :prop="item.field"
                        :label="item.column_name"
                        :width="item.column_width"
                        v-else-if="item.column_name == '单号' && item.column_status == 1"
                    >
                        <template slot-scope="scope">
                            <el-button type="text" @click="handleDetails(scope.row)">{{ scope.row[item.field] }}</el-button>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column
                        :key="item.field + index"
                        :prop="item.field"
                        :label="item.column_name"
                        :width="item.column_width"
                        v-else-if="item.column_name == '审核' && item.column_status == 1"
                    >
                        <template #default="{ row }">
                            <el-tag :type="row.check == 1 ? 'success' : 'danger'">{{ row.check == 1 ? $t('common.audited') : $t('common.notAudited') }}</el-tag>
                        </template>
                    </vxe-table-column>
                </template>

                <template #empty>
                    <span style="color: red">
                        <img src="@/assets/img/dontHave.png" style="width: 180px" />
                    </span>
                </template>
            </vxe-table>
            <div class="pagination" style="text-align: right">
                <el-pagination
                    background
                    layout="total,sizes, prev, pager, next"
                    :current-page="query.page"
                    :page-size="query.page_size"
                    :page-sizes="[10, 20, 30, 40]"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                    @size-change="pageSizeChange"
                ></el-pagination>
            </div>
        </div>
        <!-- 打印弹出框 -->
        <el-dialog style="padding: 0 0 20px" :title="$t('common.print')" :visible.sync="printData.isshow" width="60%">
            <el-select
                v-model="queryForm.model_name"
                placeholder="请选择模板"
                filterable
                clearable
                @change="selectPrints"
                style="width: 150px"
            >
                <el-option v-for="(item, index) in pullList.model" :key="index" :label="item.id + '-' + item.name" :value="item.id">
                </el-option>
            </el-select>
            <div class="printBox" id="print" ref="print" style="page-break-after: always; padding: 10px">
                <div v-for="(itemBig, index) in printList" style="page-break-after: always; margin-bottom: 30px">
                    <div
                        style="display: flex; align-items: center; justify-content: center; margin-bottom: 5px"
                        v-if="DataDtl.company.is_show == 1"
                    >
                        <p class="company" v-if="systemSet.company" :style="`font-size:${DataDtl.company.font_size}px;`">
                            {{ systemSet.company }}
                        </p>
                    </div>

                    <div v-if="DataDtl.title">
                        <div v-if="DataDtl.title.is_show == 1">
                            <p class="printTitle" v-if="printList.billtype_info" :style="`font-size:${DataDtl.title.font_size}px;`">
                                {{ itemBig.billtype_info.billtype_name }}
                            </p>
                        </div>
                    </div>
                    <div v-if="DataDtl.header">
                        <div v-if="DataDtl.header.is_show == 1">
                            <div class="printTop" style="margin: 5px 0 10px; padding-bottom: 5px">
                                <div>
                                    <div :style="`font-size:${DataDtl.header.font_size}px;`">客户：{{ itemBig.cust_info.cust_name }}</div>
                                    <div :style="`font-size:${DataDtl.header.font_size}px;`">备注：{{ itemBig.remark }}</div>
                                </div>
                                <div>
                                    <div :style="`font-size:${DataDtl.header.font_size}px;`">单号：{{ itemBig.payment_no }}</div>
                                    <div :style="`font-size:${DataDtl.header.font_size}px;`">日期：{{ itemBig.payment_date }}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="DataDtl.is_fields1 == 1" :style="`margin-bottom:${DataDtl.table1_bottommargin}px;`">
                        <table :border="DataDtl.is_fields1_frame == 1 ? '1' : '0'" cellpadding="0" cellspacing="0">
                            <tr align="center">
                                <template v-for="item in fields1">
                                    <template v-if="item.is_show == 1">
                                        <th
                                            :style="`width:${item.size}px;font-size:${item.font_size}px;text-align:${item.align};border:${
                                                DataDtl.is_fields1_frame == 1 ? '1px solid #000' : '0px solid white'
                                            }`"
                                            :key="item.seq"
                                        >
                                            {{ item.name }}
                                        </th>
                                    </template>
                                </template>
                            </tr>
                            <tr align="center" v-for="(item, index) in itemBig.dtl_report" :key="index">
                                <template v-for="items in fields1">
                                    <template v-if="items.is_show == 1">
                                        <td
                                            v-if="items.name == '账户'"
                                            :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                items.align
                                            };border:${DataDtl.is_fields1_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                            :key="items.seq"
                                        >
                                            {{ item.bank[items.no] || '-' }}
                                        </td>
                                        <td
                                            v-else-if="items.name == '币别'"
                                            :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                items.align
                                            };border:${DataDtl.is_fields1_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                            :key="items.seq"
                                        >
                                            {{ itemBig.currency_info.kind_name || '-' }}
                                        </td>
                                        <td
                                            v-else
                                            :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                items.align
                                            };border:${DataDtl.is_fields1_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                            :key="items.seq"
                                        >
                                            {{ item[items.no] || '-' }}
                                        </td>
                                    </template>
                                </template>
                            </tr>
                        </table>
                    </div>

                    <div v-if="DataDtl.is_tot">
                        <div v-if="DataDtl.is_tot.is_show == 1">
                            <div class="summoney">
                                <div class="sum1">
                                    <span :style="`font-size:${DataDtl.is_tot.font_size}px;`">总计 金额大写 {{ itemBig.money_type }}</span>
                                    <span :style="`font-size:${DataDtl.is_tot.font_size}px;`">{{ itemBig.money_chinese }}</span>
                                </div>
                                <div class="sum1">
                                    <span :style="`font-size:${DataDtl.is_tot.font_size}px;`">金额合计 {{ itemBig.money_type }}</span>
                                    <span :style="`font-size:${DataDtl.is_tot.font_size}px;`">{{ itemBig.money }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="DataDtl.custaccounts_begin">
                        <div
                            class="sum2"
                            v-if="DataDtl.custaccounts_begin.is_show == 1"
                            :style="`font-size:${DataDtl.custaccounts_begin.font_size}px;`"
                        >
                            <span style="color: rgb(7, 16, 114); border-right: 0; font-weight: bold">期初存欠帐（正欠负存）:</span>
                            <div style="display: flex; flex-wrap: wrap; width: 80%">
                                <p
                                    style="width: 25%; display: flex; justify-content: space-between"
                                    v-for="(item, index) in itemBig.custaccounts_begin"
                                    :key="index"
                                >
                                    <span style="margin-right: 10px">{{ item.style_name }}</span>
                                    <span style="font-weight: normal">{{ item.value }}</span>
                                </p>
                            </div>
                        </div>
                    </div>

                    <div v-if="DataDtl.custaccounts_end">
                        <div
                            class="sum2"
                            v-if="DataDtl.custaccounts_end.is_show == 1"
                            :style="`font-size:${DataDtl.custaccounts_end.font_size}px;`"
                        >
                            <span style="color: rgb(7, 16, 114); border-right: 0; font-weight: bold">期末存欠帐（正欠负存）:</span>
                            <div style="display: flex; flex-wrap: wrap; width: 80%">
                                <p
                                    style="width: 25%; display: flex; justify-content: space-between"
                                    v-for="(item, index) in itemBig.custaccounts_end"
                                    :key="index"
                                >
                                    <span style="margin-right: 10px">{{ item.style_name }}</span>
                                    <span style="font-weight: normal">{{ item.value }}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div v-if="DataDtl.custaccounts_now">
                        <div
                            class="sum2"
                            v-if="DataDtl.custaccounts_now.is_show == 1"
                            :style="`font-size:${DataDtl.custaccounts_now.font_size}px;`"
                        >
                            <span style="color: rgb(7, 16, 114); border-right: 0; font-weight: bold">本期存欠帐（正欠负存）:</span>
                            <div style="display: flex; flex-wrap: wrap; width: 80%">
                                <p
                                    style="width: 25%; display: flex; justify-content: space-between"
                                    v-for="(item, index) in itemBig.custaccounts_now"
                                    :key="index"
                                >
                                    <span style="margin-right: 10px">{{ item.style_name }}</span>
                                    <span style="font-weight: normal">{{ item.value }}</span>
                                </p>
                            </div>
                        </div>
                    </div>

                    <div v-if="DataDtl.footer">
                        <div style="display: flex; align-items: center; justify-content: space-between">
                            <div class="sumBotn" style="width: 72%; margin-right: 8%">
                                <div :style="`font-size:${DataDtl.footer.font_size}px;`" v-show="DataDtl.footer.is_show == 1">
                                    <span>制单：</span>
                                    <span v-if="printList.build_has">{{ printList.build_has.staffr_name }}</span>
                                </div>
                                <div :style="`font-size:${DataDtl.footer.font_size}px;`" v-show="DataDtl.footer.is_show == 1">
                                    <span>复核：</span>
                                    <span></span>
                                </div>
                                <div :style="`font-size:${DataDtl.footer.font_size}px;`" v-show="DataDtl.footer.is_show == 1">
                                    <span>业务员：</span>
                                    <span v-if="printList.salesman_report">{{ printList.salesman_report.staffr_name }}</span>
                                </div>
                                <div :style="`font-size:${DataDtl.footer.font_size}px;`" v-show="DataDtl.footer.is_show == 1">
                                    <span>客户签名：</span>
                                    <span></span>
                                </div>
                            </div>
                            <div style="display: inline-block; text-align: right; width: 20%">
                                <big-name v-if="DataDtl.tbrjphone_show == 1"></big-name>
                            </div>
                        </div>
                    </div>
                    <div style="margin-top: 10px" v-if="DataDtl.remark.is_show == 1">
                        <p :style="`font-size:${DataDtl.remark.font_size}px;`">{{ DataDtl.remark.content }}</p>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="toImg">转图片下载</el-button>
                <el-button type="primary" @click="printContext">直接打印</el-button>
                <el-button @click="printData.isshow = false">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 列表配置 -->
        <el-drawer title="我是标题" :visible.sync="drawers" :direction="direction" :with-header="false">
            <div class="filterKey_box">
                <div class="box_header">
                    <span>列配置</span>
                    <i class="el-icon-close icon" @click="drawers = false"></i>
                </div>
                <div class="box_content">
                    <div class="small_box">
                        <div class="text">
                            <span class="big">已显示字段</span>
                            <span class="small">拖动可调整字段顺序</span>
                        </div>
                        <ul class="ul">
                            <draggable
                                :list="keyList"
                                class="list-group"
                                ghost-class="ghost"
                                :move="checkMove"
                                animation="1000"
                                force-fallback="true"
                                chosen-class="chosen"
                            >
                                <li
                                    class="li"
                                    v-for="(item, index) in keyList"
                                    :key="index"
                                    v-show="item.column_status == 1"
                                    @mouseover="showIndex = index"
                                    @mouseleave="showIndex = null"
                                >
                                    <i class="el-icon-s-grid icon"></i>
                                    {{ item.column_name }}
                                    <i class="el-icon-error delIcon" v-show="showIndex == index" @click="liClick('del', item, index)"></i>
                                </li>
                            </draggable>
                        </ul>
                    </div>
                    <div class="small_box">
                        <div class="text">
                            <span class="big">可选字段</span>
                            <span class="small"></span>
                        </div>
                        <ul class="ul">
                            <draggable :list="keyList" :disabled="true" class="list-group" ghost-class="ghost" :move="checkMove">
                                <transition-group>
                                    <li
                                        class="li hover"
                                        v-for="(item, index) in keyList"
                                        :key="index"
                                        v-show="item.column_status == 0 && item.field_status == 1"
                                        @mouseover="optionalIndex = index"
                                        @mouseleave="optionalIndex = null"
                                        @click="liClick('add', item, index)"
                                    >
                                        <i class="el-icon-circle-plus-outline icon2" v-show="optionalIndex == index"></i>
                                        {{ item.column_name }}
                                    </li>
                                </transition-group>
                            </draggable>
                        </ul>
                    </div>
                    <div class="box_btn">
                        <!-- <el-button class="float_l" @click="reset" style="font-size: 14px">恢复默认</el-button> -->
                        <el-button @click="keycancel" style="font-size: 14px">{{ $t('common.cancel') }}</el-button>
                        <el-button @click="keyConfirm" type="primary" style="font-size: 14px">{{ $t('common.confirm') }}</el-button>
                    </div>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import {
    daletesPayment,
    allPaymentCheck,
    paymentGetList,
    apiAllSelectPay,
    apiPrintPay,
    getPrinOut_pull,
    apiGetListCorrespondingData,
    apiUpdateListCorrespondingData,
    apiCurrentPermisson
} from '@/request/api';
import html2canvas from 'html2canvas';
import { translateColumns } from '@/utils/columnI18n';
export default {
    name: 'payHistory',
    data() {
        return {
            DataDtl: { is_cunqian: {}, is_tot: {}, remark: {}, company: {} },
            fields1: [],
            queryForm: {},
            pullList: {},
            printList: {},
            printType: '',
            printData: { isshow: false, scope: null, index: 0, data: {} },
            loading: false,
            query: {
                page: 1,
                page_size: 10,
                seek: '',
                type: '1',
                start_date: '',
                end_date: '',
                check: '0',
                return: 0
            },
            pageTotal: 0,
            command: 0,
            backData: [],
            drawer: false,
            form: {},
            pullData: {},
            rules: {
                banktransfer_date: [{ required: true, message: '请选择日期', trigger: 'blur' }],
                billtype_no: [{ required: true, message: '请选择单据类型', trigger: 'blur' }],
                outbank_no: [{ required: true, message: '请选择转出银行', trigger: 'blur' }],
                intbank_no: [{ required: true, message: '请选择转入银行', trigger: 'blur' }],
                currency_no: [{ required: true, message: '请选择币别', trigger: 'blur' }],
                amt: [{ required: true, message: '请选择金额', trigger: 'blur' }]
            },
            isAdd: true,
            dialogVisible: false,
            value2: '',
            systemSet: '',
            activeName: '0',
            bonusData: [], //筛选选择数据
            arr: [], //筛选一级
            arrs: [], //筛选二级，
            rkKeyList: [],
            originalRkKeyList: [], // 保存原始的列配置（包含所有语言）
            keyList: [],
            drawers: false,
            direction: 'rtl',
            showIndex: null,
            optionalIndex: null,
            refushTable: true,
            perData: ''
        };
    },
    mounted() {
        this.systemSet = JSON.parse(localStorage.getItem('systemSet'));
        this.getData();
        this.getPull();
        this.getPulls();
        this.getTable();
        this.getPermission();

        // 监听语言变化
        this.$watch(
            () => this.$i18n ? this.$i18n.locale : localStorage.getItem('language'),
            (newLang) => {
                // 语言变化时，重新转换列名
                if (this.originalRkKeyList && this.originalRkKeyList.length > 0) {
                    this.rkKeyList = translateColumns(this.originalRkKeyList, newLang || 'zh-CN');
                }
            }
        );
    },
    methods: {
        //获得页面按钮的权限（添加，修改，删除）
        getPermission() {
            apiCurrentPermisson({
                id: '36'
            }).then((res) => {
                if (res.code == 2000) {
                    //
                    this.perData = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        getData() {
            let screen;
            if (this.bonusData.length == 0) {
                screen = '';
            } else {
                screen = JSON.stringify(this.bonusData);
            }
            if (this.query.type != 0) {
                screen = '';
            }
            paymentGetList({
                ...this.query,
                screen: screen
            }).then((res) => {
                this.backData = res.data.data;
                this.pageTotal = res.data.count;
            });
        },
        // 获取下拉框信息---------------------------------------
        getPull() {
            apiAllSelectPay({}).then((res) => {
                this.pullData = res.data;
            });
        },
        //列配置相关接口
        getTable() {
            apiGetListCorrespondingData({
                id: '35'
            }).then((res) => {
                // this.rkKeyList = res.data;
                if (res.code == 2000) {
                    // 保存原始数据（包含所有语言）
                    this.originalRkKeyList = res.data;
                    // 根据当前语言转换列名
                    this.rkKeyList = translateColumns(res.data, this.$i18n ? this.$i18n.locale : 'zh-CN');
                }
            });
        },
        changeTable() {
            this.drawers = true;
            this.keyList = this.rkKeyList.map((item) => item);
        },
        liClick(type, item, index) {
            if (type === 'del') {
                this.$set(this.keyList[index], 'column_status', '0');
            } else if (type === 'add') {
                this.$set(this.keyList[index], 'column_status', '1');
            }
        },
        checkMove(item) {},
        keycancel() {
            this.drawers = false;
            this.getTable();
        },
        keyConfirm() {
            let keyList = JSON.stringify(this.keyList);
            // let keyList = [
            //     { field: '业务员', field_name: 'salesman_name', status: '1' },
            //     { field: '修改人', field_name: 'modify_name', status: '1' },
            //     { field: '修改时间', field_name: 'modify_date', status: '1' },
            //     { field: '单号', field_name: 'payment_no', status: '1' },
            //     { field: '单据类型', field_name: 'billtype_name', status: '1' },
            //     { field: '备注', field_name: 'remark', status: '1' },
            //     { field: '审核', field_name: 'check', status: '1' },
            //     { field: '审核人', field_name: 'check_name', status: '1' },
            //     { field: '审核时间', field_name: 'check_date', status: '1' },
            //     { field: '客户', field_name: 'cust_name', status: '1' },
            //     { field: '币别', field_name: 'currency_name', status: '1' },
            //     { field: '建单人', field_name: 'build_name', status: '1' },
            //     { field: '建单时间', field_name: 'build_date', status: '1' },
            //     { field: '总金额', field_name: 'sumamt', status: '1' },
            //     { field: '日期', field_name: 'payment_date', status: '1' },
            //     { field: '本单合计换算金额', field_name: 'sumtrans_amt', status: '1' }
            // ];
            // keyList = JSON.stringify(keyList);
            apiUpdateListCorrespondingData({
                column: keyList,
                id: '35'
            }).then((res) => {
                this.drawers = false;
                if (res.code == 2000) {
                    this.$message.success(res.msg);
                    this.refushTable = !this.refushTable;
                } else if (res.code == 4000) {
                    this.$message.warning(res.data.info);
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        changeDate(value) {
            if (value) {
                this.query.type = '';
                this.query.start_date = value[0];
                this.query.end_date = value[1];
            } else {
                this.query.type = '1';
                this.query.start_date = '';
                this.query.end_date = '';
            }
        },
        changeType() {
            this.value2 = '';
            this.query.start_date = '';
            this.query.end_date = '';
        },
        // 筛选
        handleClicks() {
            if (this.activeName == '0') {
                this.bonusData = [];
            }
        },
        screen() {
            this.dialogVisible = false;
            if (this.activeName == '1') {
                this.query.type = '0';
            }
            this.getData();
        },

        // 筛选功能--------------------------------------------------
        showInput() {
            let item = { field: '', condition: '', parameter: '' };
            this.bonusData.push(item);
        },
        selectOne(val) {
            //二级条件
            let arr = this.pullData.screen_pull.filter((item) => {
                return item.table == val;
            });
            this.arr = arr[0].field;
        },
        selectOne1(index, val) {
            // 三级数据
            let arrs = this.pullData.screen_pull[0].field.filter((item) => item.name_no == val);
            // let arrs = this.pullData.screen_pull[0][index];
            if (arrs[0].select) {
                this.arrs[index] = arrs[0].select;
            } else {
                this.arrs[index] = [];
            }
        },
        deleteRow(index, rows) {
            rows.splice(index, 1);
        },
        // 切换日期搜素
        handleClick(tab, event) {
            this.value2 = '';
            this.query.start_date = '';
            this.query.end_date = '';
            this.getData();
        },
        // 搜索
        searchIt() {
            this.bonusData = [];
            this.getData();
        },
        // 批量操作
        handleCommand(command) {
            if (command == 4) {
                this.deleteIts();
                // this.outExcel();
            } else if (command == 1) {
                this.check(command);
            } else if (command == 2) {
                this.outExcel(1);
                // document.querySelector('.biaoge input').click();
            } else if (command == 3) {
                this.printOut();
            } else if (command == 6) {
            }
        },
        deleteIts() {
            let data = this.$refs.table.getCheckboxRecords();
            if (data.length == 0) {
                this.$message.warning('请选择需要操作的数据');
                return;
            }
            let idArr = [];
            data.forEach((item) => {
                idArr.push(item.payment_no);
            });
            let ids = idArr.join(',');
            this.$confirm('确定要删除该付款单吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    daletesPayment({
                        payment_no: ids
                    }).then((res) => {
                        if (res.code == 2000) {
                            this.$message({ message: '删除成功', type: 'success' });
                            this.getData();
                        } else {
                            let str = [];
                            var s = '';
                            str = res.data.info;
                            for (let i = 0; i < str.length; i++) {
                                s += str[i] + '<br/>';
                            }
                            this.$message({
                                type: 'error',
                                showClose: true,
                                duration: 0,
                                dangerouslyUseHTMLString: true,
                                message: s
                            });
                        }
                    });
                })
                .catch(() => {});
        },
        // 打印-----------------------
        toImg() {
            html2canvas(this.$refs.print, {
                backgroundColor: 'white',
                useCORS: true,
                windowHeight: document.body.scrollHeight
            }).then((canvas) => {
                // let url = canvas.toDataURL('image/jpeg', 1.0)
                let url = canvas.toDataURL();
                this.img = url;
                this.download();
                // printJS(
                //   {
                //     printable: url,
                //     type: 'image',
                //     documentTitle: '打印图片'
                //   }
                // )
            });
        },
        //下载图片
        download() {
            let imgData = this.img;
            this.downloadFile('付款管理.png', imgData);
        },
        //下载
        downloadFile(fileName, content) {
            let aLink = document.createElement('a');
            let blob = this.base64ToBlob(content); //new Blob([content]);

            let evt = document.createEvent('HTMLEvents');
            evt.initEvent('click', true, true); //initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
            aLink.download = fileName;
            aLink.href = URL.createObjectURL(blob);

            // aLink.dispatchEvent(evt);
            //aLink.click()
            aLink.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window })); //兼容火狐
        },
        //base64转blob
        base64ToBlob(code) {
            let parts = code.split(';base64,');
            let contentType = parts[0].split(':')[1];
            let raw = window.atob(parts[1]);
            let rawLength = raw.length;

            let uInt8Array = new Uint8Array(rawLength);

            for (let i = 0; i < rawLength; ++i) {
                uInt8Array[i] = raw.charCodeAt(i);
            }
            return new Blob([uInt8Array], { type: contentType });
        },
        printContext() {
            this.$print(this.$refs.print);
        },
        printOut() {
            this.getPulls();
            let data = this.$refs.table.getCheckboxRecords();
            if (data.length == 0) {
                this.$message.warning('请选择需要操作的数据');
                return;
            }
            let idArr = [];
            data.forEach((item) => {
                idArr.push(item.payment_no);
            });
            let ids = idArr.join(',');
            const loading = this.$loading({
                lock: true,
                text: '打印加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            apiPrintPay({
                payment_no: ids,
                printId: this.queryForm.model_name
            }).then((res) => {
                if (res.code == 2000) {
                    this.printData.isshow = true;
                    loading.close();
                    this.printList = res.data.dtl;
                    this.DataDtl = res.data.model_data;
                    this.fields1 = this.DataDtl.fields1;
                } else {
                    loading.close();
                    this.$message.error(res.data.info);
                }
            });
        },
        // 选择打印下拉框-----------------------
        selectPrints(val) {
            let modelList = this.pullList.model;
            this.printType = modelList.find((item) => item.id == val).name;
            let id = modelList.find((item) => item.id == val).id;
            // this.handleDtl(val);
            this.queryForm.model_name = val;
            // this.printOut();
            this.printOutTwo();
            this.$forceUpdate();
        },
        getPulls() {
            let path_code = this.$route.path.replace('/', '');
            getPrinOut_pull({ code: 'paymanage' }).then((res) => {
                this.pullList = res.data;
                this.queryForm.model_name = this.pullList.model_data.id;
                this.printType = this.pullList.model_data.name;
            });
        },
        printOutTwo() {
            let data = this.$refs.table.getCheckboxRecords();
            if (data.length == 0) {
                this.$message.warning('请选择需要操作的数据');
                return;
            }
            let idArr = [];
            data.forEach((item) => {
                idArr.push(item.payment_no);
            });
            let ids = idArr.join(',');
            const loading = this.$loading({
                lock: true,
                text: '打印加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            apiPrintPay({
                payment_no: ids,
                printId: this.queryForm.model_name
            }).then((res) => {
                if (res.code == 2000) {
                    this.printData.isshow = true;
                    loading.close();
                    this.printList = res.data.dtl;
                    this.DataDtl = res.data.model_data;
                    this.fields1 = this.DataDtl.fields1;
                } else {
                    loading.close();
                    this.printOut();
                }
            });
        },
        // 导出
        outExcel(type) {
            let data = this.$refs.table.getCheckboxRecords();
            var ids = '';
            if (data.length > 0) {
                let idArr = [];
                data.forEach((item) => {
                    idArr.push(item.payment_no);
                });
                ids = idArr.join(',');
            }

            let screen;
            if (this.bonusData.length == 0) {
                screen = '';
            } else {
                screen = JSON.stringify(this.bonusData);
            }
            if (this.query.type != 0) {
                screen = '';
            }
            let query = this.query;
            delete query.page;
            delete query.page_size;
            this.$axios
                .get(this.$baseURL + 'payments_export', {
                    params: {
                        payment_no: ids,
                        ...this.query,
                        screen
                    },
                    responseType: 'arraybuffer'
                })
                .then((response) => {
                    //创建一个blob对象,file的一种
                    let blob = new Blob([response.data], { type: 'application/x-xls' });
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = '付款单.xlsx';
                    link.click();
                });
        },

        // 审核
        check(command) {
            let data = this.$refs.table.getCheckboxRecords();

            if (data.length == 0) {
                this.$message.warning('请选择需要操作的数据');
                return;
            }

            let idArr = [];
            data.forEach((item) => {
                idArr.push(item.payment_no);
            });
            let ids = idArr.join(',');
            allPaymentCheck({
                payment_no: ids,
                check: 1
            }).then((res) => {
                if (res.code == 2000) {
                    this.$message.success(res.msg);
                    this.getData();
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        // 新建
        add() {
            // this.$router.push('/' + this.$route.query.page);
            this.$router.push({
                path: '/' + this.$route.query.page,
                query: {
                    isadd: '0'
                }
            });
        },

        refush() {
            (this.query = {
                page: 1,
                page_size: 10,
                seek: '',
                type: '1',
                start_date: '',
                end_date: '',
                check: '0'
            }),
                this.getData();
        },
        // //跳转
        handleDetails(row) {
            this.$router.push({
                path: '/' + this.$route.query.page,
                query: {
                    bill_no: row.payment_no
                }
            });
        },
        // 表尾合计-----------------------------------------------
        footerMethod({ columns, data }) {
            return [
                columns.map((column, columnIndex) => {
                    if (columnIndex === 0) {
                        return '合计';
                    } else if (column.property == 'sumqty') {
                        return `${this.$utils.sum(data, column.property).toFixed(this.systemSet.qty)}`;
                    } else if (column.property == 'sumwgt') {
                        return `${this.$utils.sum(data, column.property).toFixed(this.systemSet.wgt)}`;
                    } else if (column.property == 'sumamt') {
                        return `${this.$utils.sum(data, column.property).toFixed(this.systemSet.wgt)}`;
                    } else if (column.property == 'sumtrans_amt') {
                        return `${this.$utils.sum(data, column.property).toFixed(this.systemSet.wgt)}`;
                    } else if (column.property == 'balqty_wgt') {
                        return `${this.$utils.sum(data, column.property).toFixed(this.systemSet.wgt)}`;
                    } else if (column.property == 'payment_qty') {
                        return `${this.$utils.sum(data, column.property).toFixed(this.systemSet.qty)}`;
                    } else if (column.property == 'tran_wgt') {
                        return `${this.$utils.sum(data, column.property).toFixed(this.systemSet.wgt)}`;
                    } else if (column.property == 'tran_qty') {
                        return `${this.$utils.sum(data, column.property).toFixed(this.systemSet.qty)}`;
                    } else if (column.property == 'settle_amt') {
                        return `${this.$utils.sum(data, column.property).toFixed(this.systemSet.amt)}`;
                    } else if (column.property == 'amt_pay') {
                        return `${this.$utils.sum(data, column.property).toFixed(this.systemSet.amt)}`;
                    } else {
                        return '-';
                    }
                })
            ];
        },
        //分页导航----------------------------------------------------------------------------------------------------
        handlePageChange(val) {
            this.query.page = val;
            this.getData();
        },
        pageSizeChange(val) {
            this.query.page_size = val;
            this.getData();
        }
    }
};
</script>

<style scoped lang="scss">
/deep/.el-tabs__nav-wrap::after {
    background-color: #fff;
}
/deep/.el-tabs__item {
    width: 66px;
    text-align: center;
    padding: 0;
    font-size: 12px;
}
/deep/.el-tabs__active-bar {
    width: 66px !important;
}
/deep/.el-drawer__header {
    border-bottom: 1px solid #e7e7e7;
    color: #000;
    font-size: 16px;
    margin: 0;
    padding: 15px 20px;
}
.header_warpper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
    padding: 0 15px;
    padding-top: 15px;
    box-sizing: border-box;
    .left {
        display: flex;
        align-items: center;
    }
}
.drawer {
    width: 100%;
    height: 100%;
    position: relative;
}
.dialog-footer {
    width: 100%;
    position: absolute;
    right: 0px;
    bottom: 0px;
    border-top: 1px solid #e7e7e7;
    text-align: right;
    height: 56px;
    line-height: 56px;
    padding: 0 20px;
    box-sizing: border-box;
}
.dialog_warpper {
    background-color: #fff;
    padding: 15px;
    box-sizing: border-box;
    margin: 15px 0;
    min-height: 400px;
    position: relative;
    padding-bottom: 56px;
}
.box1 {
    width: 600px;
    margin-top: 10px;
}
.box2 {
    width: 520px;
}
.dialog {
    .block {
        display: flex;
        margin-bottom: 15px;
        p {
            display: inline-block;
            width: 88px;
            color: #666;
            font-size: 14px;
        }
    }
}
.table {
    background-color: #fff;
    padding: 15px;
    box-sizing: border-box;
}
/deep/.el-tabs__header {
    margin-bottom: 0;
}
// /deep/ .el-tabs__active-bar {
//     display: none;
// }
// 打印样式
.printBox table {
    width: 100%;
    border-collapse: collapse;
    border: none;
}

.printBox table td,
.printBox table th {
    border: 1px solid #000;
    font-size: 12px;
}

.printBox table th {
    font-weight: bold;
    color: #000;
}

.company {
    font-size: 13px;
    color: rgb(7, 16, 114);
    font-weight: bold;
}

.printTitle {
    text-align: center;
    font-size: 17px;
    color: #000;
    font-weight: bold;
    letter-spacing: 5px;
}

.printTop {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    font-size: 16px;
    color: #000;
    border-bottom: 1px solid rgb(7, 16, 114);
}

.printTop div label {
    color: rgb(7, 16, 114);
    font-weight: bold;
    font-size: 12px;
}

.printTop div p {
    line-height: 1.25;
}

.printBox .tableName {
    font-size: 12px;
    padding: 2px 0;
    color: rgb(7, 16, 114);
    font-weight: bold;
}
.summoney {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 90%;
    margin: 10px 0 5px;
}

.summoney .sum1 span:nth-child(1) {
    color: rgb(7, 16, 114);
    font-weight: bold;
    font-size: 12px;
}

.summoney .sum1 span:nth-child(2) {
    font-size: 12px;
    color: #000;
    margin-left: 20px;
}

.insummoney {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px 15% 5px 0;
    border-bottom: 1px solid #000;
}

.insummoney .sum1 span:nth-child(1) {
    color: rgb(7, 16, 114);
    font-weight: bold;
    font-size: 12px;
}

.insummoney .sum1 span:nth-child(2) {
    font-size: 12px;
    color: #000;
    margin-left: 20px;
}

.sum2 {
    border-bottom: 1px solid rgb(7, 16, 114);
    padding: 1px 0;
    display: flex;
    align-items: flex-start;
}

.sum2 p {
    color: #000;
    font-weight: normal;
    border-right: 1px solid #000;
    padding: 0 5px;
}

.sumBotn {
    display: flex;
    justify-content: space-between;
    width: 85%;
    margin: 5px 0;
}

.sumBotn p span {
    font-size: 14px;
    color: #000;
}

.sumBotn div span:first-child {
    color: rgb(7, 16, 114);
    font-weight: bold;
}

.img {
    padding-right: 5px;
}
</style>
